import React from "react";
import "./FieldNameValue.scss"; // Use a common SCSS file for styling
const FieldNameValue = ({ fieldName, fileldValue }) => {
  return (
    <>
      {" "}
      <div className="fieldConatiner">
        {" "}
        <p className="fileldValue">{fileldValue}</p>
        <p className="fieldName">{fieldName}</p>
      </div>
    </>
  );
};

export default FieldNameValue;
